module.exports = __webpack_public_path__ + "img/password_bg.png";